<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import VacationCard from "@modern/components/distributor/vacations/VacationCard.svelte";
  import VacationModal from "@modern/components/distributor/vacations/VacationModal.svelte";

  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  import type { DistributorVacation } from "@shared/types/Distributor";

  let vacations: DistributorVacation[] = [];
  let showVacationModal: boolean;
  let vacationToEdit: DistributorVacation = {};
  let showOrEditModal: string;

  const vacationsRes = async () => {
    try {
      let res = await HttpPromise({
        method: "GET",
        url: "/api/distributor/sales_rep_vacations",
      });
      vacations = res;
    } catch {
      vacations = [];
    }
  };

  const addNewVacation = () => {
    vacationToEdit = {};
    showOrEditModal = "new";
    showVacationModal = true;
  };

  const load = async () => {
    await vacationsRes();
  };
</script>

{#await load()}
  <Spinner />
{:then}
  <div class="distributor-page" data-testid="distributor-vacations">
    <FizzStyles>
      <div class="fizz-stack-32 fizz-surface fizz-flex-row fizz-inset-square-16 fizz-space-between">
        <h4 class="fizz-heading-4">Vacations</h4>
        <button class="fizz-button-primary" on:click={addNewVacation}>Schedule Vacation</button>
      </div>

      <div class="fizz-inset-horizontal-32 fizz-container-medium">
        {#each vacations as vacation}
          <div class="fizz-inset-vertical-8 fizz-full-width">
            <VacationCard
              {vacation}
              bind:showVacationModal
              bind:vacationToEdit
              bind:showOrEditModal
            />
          </div>
        {/each}
        {#if vacations.length == 0}
          <div class="inset-horizontal-32">
            <div class="fizz-text-large body"> No Vacations Scheduled </div>
          </div>
        {/if}
      </div>
      <VacationModal
        bind:showVacationModal
        bind:showOrEditModal
        bind:vacationToEdit
        bind:vacations
      />
    </FizzStyles>
  </div>
{/await}
